const isDev = process.env.NODE_ENV !== 'production';

export const devLog = {
  error: (...args) => isDev && console.error('[Betherapy]', ...args),
  warn: (...args) => isDev && console.warn('[Betherapy]', ...args),
  info: (...args) => isDev && console.info('[Betherapy]', ...args)
};
